import { render, staticRenderFns } from "./CourseItemDetail.vue?vue&type=template&id=1bbaff60&scoped=true&"
import script from "./CourseItemDetail.vue?vue&type=script&lang=js&"
export * from "./CourseItemDetail.vue?vue&type=script&lang=js&"
import style0 from "./CourseItemDetail.vue?vue&type=style&index=0&id=1bbaff60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbaff60",
  null
  
)

export default component.exports